import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const POLL_MS = 60 * 1000;

export const SYNC_EVENT = "kipkruiden-webshop-synced";

export function useWebshopStatus() {
  const [status, setStatus] = useState(null);
  const [syncing, setSyncing] = useState(false);

  const load = useCallback(() => api.get("/woocommerce/status").then((r) => setStatus(r.data)).catch(() => {}), []);

  const syncNow = useCallback(async () => {
    setSyncing(true);
    try {
      const { data } = await api.post("/woocommerce/sync");
      setStatus(data);
      window.dispatchEvent(new Event(SYNC_EVENT));
      return data;
    } finally { setSyncing(false); }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, POLL_MS);
    window.addEventListener(SYNC_EVENT, load);
    return () => { clearInterval(t); window.removeEventListener(SYNC_EVENT, load); };
  }, [load]);

  return { status, syncing, syncNow, reload: load };
}
